import React from "react";
import "./Vission_Mission.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Vission_Mission = () => {
  return (
    <section className="Vission_Mission">
      <div className="container">
        <Common_Title
          pageTitle="VISION - MISSION"
          boxText="Innovation "
          subText="Leading Future Spaces  "
          darkText="We are the premier interior design firm, renowned for creating beautiful, functional, and deeply personal spaces that enhance the lives of our clients."
        />

        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="white_card">
              <p className="card_heading">Our Vision</p>
              <p className="descn">
                Our vision is to be recognized as one of the most trusted and
                innovative interior design companies in India, known for
                transforming homes and workplaces into inspiring environments.
                We aim to combine creativity, technology, and precision to
                redefine interior living, while continuously expanding our reach
                beyond Pune and Maharashtra to a national and global presence.
              </p>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="white_card">
              <p className="card_heading">Our Mission</p>
              <p className="descn">
                At Tech Interiors and Designers, our mission is to create
                functional, elegant, and personalized spaces that truly reflect
                our clients’ lifestyles. We are committed to delivering
                top-quality interiors through skilled craftsmanship, premium
                materials, and innovative design solutions. By working closely
                with our clients, we ensure every project is completed on time,
                within budget, and beyond expectations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vission_Mission;
